<template>
  <div class="date-selector">
    <!-- Component Body -->
    <DatePicker
      :value="selectedDate"
      :config="options"
      :class="inputClasses"
      @dp-change="selectDate($event)"
    />
  </div>
</template>

<script>
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import DatePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'

import { inputClassList } from '@/mixins/inputClassList.js'
import { datePickerConfig } from '@/services/datePickerConfig.js'

export default {
  name: 'date-selector',
  mixins: [inputClassList],
  components: {
    DatePicker
  },
  data() {
    return {
      selectedDate: null,
      options: datePickerConfig
    }
  },
  props: {
    inputKey: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    isValidField: {
      type: Boolean,
      required: false,
      default: true
    },
    isRecommendedField: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  methods: {
    selectDate(event) {
      if (event) {
        this.$emit('inputChanged', moment(event.date).format('YYYY-MM-DD'))
      }
    }
  },
  mounted() {
    if (!!this.value) {
      this.selectedDate = this.value
    }
  },
  watch: {
    "$store.state.formInputs.szuletesi_datum": {
      handler: function (newVal, oldVal) {
        if (newVal && this.inputKey !== 'szuletesi_datum') {
          this.options = {
            ...this.options,
            minDate: moment(newVal).format('YYYY-MM-DD')
            
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/*** Component Style ***/
.date-selector {
  position: relative;
}
</style>
